import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'

const Select = () => {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreRoundedIcon,
      },

      styleOverrides: {
        root: {},
      },
    },
  }
}

export default Select
